import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';
import { Playlist } from '../../models';
import { PlaylistService } from '../../services';

@Component({
  selector: 'add-playlist-dialog',
  templateUrl: './add-playlist-dialog.html',
  styles: []
})
export class AddPlaylistDialogComponent implements OnInit {
  playlistName = '';

  constructor(
    public dialogRef: MatDialogRef<AddPlaylistDialogComponent>,
    public playlistService: PlaylistService,
    @Inject(MAT_DIALOG_DATA) public matchId: string
  ) {}

  ngOnInit(): void {}

  onCreateClick(): void {
    console.info('Entered: ', this.playlistName);

    const playlist: Playlist = {
      name: this.playlistName,
      matchId: this.matchId,
      userId: '',
      items: []
    };

    this.playlistService.add(playlist);
    this.dialogRef.close(playlist);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
